module.exports = __webpack_public_path__ + "img/wx.9e003bd7.jpg";